// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import manageBulkUsers from './manageBulkUsers';

import { IRoute } from '../';

const manageBulkUsersRoutes: IRoute[] = [
    {
        crumbText: 'manage_bulk_users',
        component: manageBulkUsers,
        exact: true,
        path: '/manageUsers/manageBulkUsers',
    },
];

export default manageBulkUsersRoutes;